// Status pill. The colour classes come from the caller's status map so project
// and job statuses keep the colours they have elsewhere in the app.
const Badge = ({ children, className = "bg-gray-100 text-gray-600" }) => (
  <span
    className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ${className}`}
  >
    {children}
  </span>
);

export default Badge;
